import React, { FC } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { CustomTab } from '../../commons/CustomTab';
import { TabPanel } from '../../commons/CustomTab/TabPanel';
import { ChangeServiceTypes } from '../../../models/Accounts';
import { ChangeServiceCard } from '../ChangeServiceCard';

interface ChangeServiceTabsProps {
  tabValue: number;
  handleSetTabValue: (event: React.SyntheticEvent | SelectChangeEvent, newValue: number) => void;
  availableServiceGroups: ChangeServiceTypes[];
  handleChange: (id: string | number, isDaily: boolean, isCurrent: boolean) => void;
  handleCallback: (serviceName: string, serviceAnalyticsName: string) => void;
  canChange: boolean;
  canActivate: boolean;
}

export const ChangeServiceTabs: FC<ChangeServiceTabsProps> = ({
  tabValue,
  handleSetTabValue,
  availableServiceGroups,
  handleChange,
  handleCallback,
  canChange,
  canActivate,
}) => {
  return (
    <>
      <CustomTab
        tabValue={tabValue}
        setTabValue={handleSetTabValue}
        orientation="horizontal"
        tabs={availableServiceGroups.map((el, index) => {
          return { label: el.Name, id: index };
        })}
      />
      {availableServiceGroups.map((el, index) => {
        return (
          <TabPanel value={tabValue} index={index} key={el.TypeId}>
            {el.Services.map((service) => {
              return (
                <ChangeServiceCard
                  isAvailableForConnection={service.isAvailableForConnection}
                  isDaily={service.Daily}
                  description={service.Description}
                  canChange={canChange}
                  canActivate={canActivate}
                  name={service.Name}
                  price={service.Price}
                  key={service.id}
                  iconType={service.icon}
                  isCurrent={service.isCurrent}
                  isPrepaid={service.isPrepaid}
                  isCashback={service.isCashback}
                  handleChange={handleChange}
                  serviceId={service.id}
                  handleCallback={handleCallback}
                  serviceAnalyticsName={service.AnalyticsID}
                />
              );
            })}
          </TabPanel>
        );
      })}
    </>
  );
};
